export default function isNumberOrTrue(value) {
  return !!value || value === 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/es/utils/isNumberOrTrue.js
// module id = 2140
// module chunks = 31